import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import { colors } from "@zapalacorp/tokens";
import { DiaryContainer } from "../../shared/DiaryContainer";
import Modal from "Components/Generic/Modal";
import { Badge, BadgeProps } from "reactstrap";

export const useStyles = makeStyles(() => ({
  selectedDataCard: {
    borderRadius: "4px",
    background: colors.white,
    marginBottom: "8px",
    padding: "8px 16px",
    width: "368px",
    minHeight: "40px",
    columnGap: "24px",
    "& img": {
      marginRight: "12px",
    },
    "& span": {
      color: colors.gray400,
      textOverflow: "ellipsis",
      fontFamily: "Manrope",
      fontSize: "14px",
      fontWeigth: 400,
      lineHeight: "20px",
      letterSpacing: "0.25px",
    },
  },

  container: {
    position: "relative",
    display: "flex",
    padding: "10px 15px",
    height: "auto",
    backgroundColor: colors.white,
    gap: "24px",
  },
  arrow: {
    cursor: "pointer",
    fontSize: "24px",
    "&:hover": {
      color: colors.gray200,
    },
  },
  arrowIcon: {
    marginRight: "12px",
  },
  DateNavigation: {
    display: "flex",
    alignItems: "center",
    height: "36px",
    padding: "4px",
  },
  commentBody: {
    width: "100%",
  },
  subbody: {
    display: "flex",
    width: "100%",
  },
  mainAvatar: {
    width: "30px",
    height: "30px",
    marginTop: "10px",
  },
  avatar: {
    width: "30px",
    height: "30px",
  },
  actionBtnbox: {
    display: "flex",
    marginLeft: "55px",
    justifyContent: "space-between",
  },
  dateText: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#465869",
    fontFamily: "Manrope, sans-serif",
    fontStyle: "normal",
    lineHeight: "28px",
    marginRight: "8px",
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "& img": {
      padding: "6px",
      width: "38px",
      height: "38px",
      cursor: "pointer",
      border: "0.6px solid transparent",
      borderColor: colors.brandBlue500,
      borderRadius: "8px",
      transition: "border-color 0.3s",
    },
  },
  menuPaperProps: {
    width: "620px",
    marginTop: "50px",
    marginLeft: "-17px",
  },
  menuOptionsPaperProps: {
    width: "320px",
  },
  accordian: {
    width: "auto",
    padding: "0",
  },
  leftpanelItem: {
    border: `1px solid ${colors.white}`,
    minWidth: "200px",
    overflowY: "scroll",
    width: "100%",
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: colors.gray500,
      borderRadius: "8px",
    },
  },

  serachInput: {
    borderRadius: "3px",
    minWidth: "90%",
  },
  inputContainer: {
    backgroundColor: colors.gray100,
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    alignItems: "center",

    "& .MuiFormControl-root": {
      minWidth: "85%",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: colors.gray300,
        },
        "&:hover fieldset": {
          borderColor: colors.gray300,
        },
        "&.Mui-focused fieldset": {
          borderColor: colors.gray300,
        },
        "&.Mui-focused": {
          borderColor: colors.gray300,
        },
      },
    },
  },
  mainContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  pannelheader: {
    color: "colors.gray600",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
    marginRight: "15px",
    marginLeft: "15px",
  },
  mainDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "24px",
    width: "100%",
  },
  subtitle: {
    font: "normal 500 16px/24px Manrope",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "24px",
    width: "100%",
  },
  filterImg: {
    marginLeft: "10px",
  },
  searchInput: {
    padding: "8px",
    fontSize: "16px",
    marginBottom: "10px",
    width: "100%",
    boxSizing: "border-box",
  },
  card: {
    display: "flex",
    alignItems: "center",
    width: "auto",
  },
  menubtnBox: {
    height: "100px",
    widht: "490px",
  },
  image: {
    padding: "16px",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    marginRight: "10px",
    marginLeft: "15px",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    width: "auto",
  },
  name: {
    margin: 0,
    fontSize: "14px",
    fontWeight: 400,
    color: colors.gray600,
    lineHeight: "20px",
  },
  tasks: {
    margin: 0,
    fontSize: "12px",
    color: colors.gray500,
    fontWeight: 600,
    lineHeight: "16px",
  },

  activeMenuItem: {
    color: colors.gray600,
    fontFamily: "Manrope, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
  },
  disabledMenuItem: {
    color: colors.gray400,
    fontFamily: "Manrope, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    pointerEvents: "none",
  },
  menuItem: {
    color: colors.gray600,
    fontFamily: "Manrope, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
  },
  subheadingMenuItem: {
    color: colors.gray600,
    fontFamily: "Manrope, sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    padding: "8px 16px",
  },
  menuIcon: {},
  menuButton: {
    marginLeft: "auto",
  },

  menu: {},
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  sectionTitle: {
    marginBottom: "8px",
  },
  collapseContent: {
    paddingLeft: "16px",
  },
  button: {
    marginBottom: "16px",
  },
  flexBetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
  },
}));

export const DespatchContainer = styled(DiaryContainer, {
  name: "despatchContainer",
})(() => ({
  backgroundColor: colors.gray50,
  borderBottomRightRadius: "12px",
  borderBottomLeftRadius: "12px",
}));

export const UserProfileMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    backgroundColor: colors.white,
    borderRadius: "12px",
    overflow: "visible",
    boxShadow: "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)",
  },
  "& .MuiList-padding": {
    padding: "0px",
  },
}));
export const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    top: 10,
    border: `2px solid ${theme.palette.background.paper}`,
    backgroundColor: colors.gray500,
    color: theme.palette.getContrastText(colors.gray500),
    padding: "4px",
  },
}));
export const CommentBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    top: 13,
    right: 10,
    marginLeft: "20px",
    border: `2px solid ${theme.palette.background.paper}`,
    backgroundColor: colors.gray600,
    color: theme.palette.getContrastText(colors.gray500),
    padding: "4px",
  },
}));
export const ModalText = styled("p")(() => ({
  color: colors.gray600,
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "150%",
  fontFamily: "Manrope",
}));

export const DeleteText = styled("p")(() => ({
  fontWeight: 400,
  fontSize: 16,
  lineHeight: "150%",
  color: colors.error500,
  fontFamily: "Manrope",
}));

export const CustomModal = styled(Modal)(() => ({
  // width: "700px !important",
  overflow: "hidden !important",
  "& .MuiModal-root": {
    overflow: "hidden !important",
  },
  "& .makeStyles-modalBody": {
    overflow: "hidden !important",
    backgroundColor: "red  !important",

    "& :nth-of-type(2)": {
      backgroundColor: "red",
      // padding: '0px', // Example usage
    },
  },
}));

export const CommentsCount = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "topMargin";
  },
})<{ topMargin?: string }>(({ topMargin }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  top: topMargin ?? "0px",
  right: "-8px",

  background: colors.error500,
  borderRadius: "100px",
  color: colors.white,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "11px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  minHeight: "16px",
  minWidth: "16px",
  padding: "0 2px",
}));

export const useStyles2 = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 15px",
    height: "auto",
    // border: "2px solid black",
  },
  arrow: {
    cursor: "pointer",
    fontSize: "24px",
    margin: "8px",
    "&:hover": {
      color: colors.brandBlue500,
    },
  },
  commentBody: {
    width: "100%",
  },
  subbody: {
    display: "flex",
    width: "100%",
  },
  mainAvatar: {
    width: "30px",
    height: "30px",
    marginTop: "10px",
  },
  avatar: {
    width: "30px",
    height: "30px",
  },
  actionBtnbox: {
    display: "flex",
    marginLeft: "55px",
    justifyContent: "space-between",
  },
  dateText: {
    margin: "16px",
    fontSize: "22px",
    fontWeight: 600,
    color: "#465869",
    fontFamily: "Manrope, sans-serif",
    fontStyle: "normal",
    lineHeight: "28px",
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "& img": {
      padding: "6px",
      width: "38px",
      height: "38px",
      cursor: "pointer",
      border: "2px solid transparent",
      transition: "border-color 0.3s",
    },
    "& img.selected": {
      borderColor: colors.brandBlue500,
      borderRadius: "8px",
    },
  },
  selectedButton: {
    borderColor: colors.brandBlue500,
    borderRadius: "6px",
  },

  menuPaperProps: {
    width: "620px",
    marginTop: "50px",
    marginLeft: "-17px",
  },
  menuOptionsPaperProps: {
    width: "320px",
  },
  accordian: {
    width: "auto",
    padding: "0",
  },
  leftpanelItem: {
    height: "100vh",
    minWidth: "250px",
    width: "auto",
  },

  serachInput: {
    borderRadius: "3px",
    minWidth: "90%",
  },
  inputContainer: {
    backgroundColor: colors.gray100,
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    alignItems: "center",

    "& .MuiFormControl-root": {
      minWidth: "85%",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: colors.gray300,
        },
        "&:hover fieldset": {
          borderColor: colors.gray300,
        },
        "&.Mui-focused fieldset": {
          borderColor: colors.gray300,
        },
        "&.Mui-focused": {
          borderColor: colors.gray300,
        },
      },
    },
  },
  rightpanel: {
    border: "1px solid grey",
    height: "100vh",
    minWidth: "280px",
  },
  mainContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  pannelheader: {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
    marginRight: "15px",
    marginLeft: "15px",
  },
  mainDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "24px",
    width: "100%",
  },
  subtitle: {
    font: "normal 500 16px/24px Manrope",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "24px",
    width: "100%",
  },
  filterImg: {
    marginLeft: "10px",
  },
  searchInput: {
    padding: "8px",
    fontSize: "16px",
    marginBottom: "10px",
    width: "100%",
    boxSizing: "border-box",
  },
  card: {
    display: "flex",
    alignItems: "center",
    width: "auto",
  },
  menubtnBox: {
    height: "100px",
    widht: "490px",
  },
  image: {
    padding: "16px",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    marginRight: "10px",
    marginLeft: "15px",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    width: "auto",
  },
  name: {
    margin: 0,
    fontSize: "14px",
    fontWeight: 400,
    color: colors.gray600,
    lineHeight: "20px",
  },
  tasks: {
    margin: 0,
    fontSize: "12px",
    color: colors.gray500,
    fontWeight: 600,
    lineHeight: "16px",
  },
  btnmenulist: {
    color: colors.gray500,
    fontWeight: 600,
    lineHeight: "16px",
  },
  activeMenuItem: {
    color: colors.gray600,
    fontFamily: "Manrope, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    "&:hover": {
      backgroundColor: colors.white,
    },
  },
  disabledMenuItem: {
    color: colors.gray400,
    fontFamily: "Manrope, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    pointerEvents: "none",
    backgroundColor: colors.white,
  },
  subheadingMenuItem: {
    color: colors.gray600,
    fontFamily: "Manrope, sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
  menuIcon: {
    marginRight: "8px",
  },
  menuButton: {
    marginLeft: "auto",
  },
  menu: {
    // width:"250px",
    "& .MuiPaper-root": {
      borderRadius: "12px",
      width: "256px",
    },
  },
  menuPaper: {
    borderRadius: "8px",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  MainModalContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginBottom: "20px",
    marginTop: "10px",
  },
  sectionTitle: {
    marginBottom: "8px",
    color: "#465869",
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  collapseContent: {
    paddingLeft: "6px",
  },
  modalmenu: {
    width: "408px",
    height: "auto",
    borderRadius: "12px",
    padding: "12px 0px",
  },
  button: {
    marginBottom: "26px",
    color: colors.brandBlue500,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
    textTransform: "none",
  },
  menulistbox: {
    overflowY: "scroll",
    height: "300px",
  },
  reference: {
    borderRadius: "8px 0 0 8px",
    border: `1px solid ${colors.gray300}`,
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    backgroundColor: colors.gray50,
    textTransform: "none",
    "& .MuiBox-root": {
      height: "40px !important",
      padding: "0px",
      borderRadius: "8px 0 0 8px !important",
      border: `1px solid ${colors.gray300}`,
      width: "100px",
    },
    "&:focus": {
      border: `1px solid ${colors.gray300}`,
    },
    "&:blur": {
      border: `1px solid ${colors.gray300}`,
    },
  },
  general: {
    marginRight: "10px",
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    textTransform: "none",
    "& .MuiBox-root": {
      height: "40px !important",
      width: "100px",
    },
  },

  cardtextplacer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "& .MuiBadge-badge": {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0.5,
      backgroundColor: colors.success50,
    },
  },
  commentActionButtonText: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    letterSpacing: "0.4px",
    lineHeight: "16px",
    color: colors.gray500,
    "&.bold": {
      fontWeight: 700,
    },
    "&.regular": {
      fontWeight: 400,
    },
  },
  characterCount: {
    color: colors.gray500,
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "16px",
    letterSpacing: "0.4px",
  },
  commentHistory: {
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    marginRight: "30px",
  },
  commentBadge: {
    backgroundColor: colors.gray600,
    color: colors.white,
    padding: "2px 4px",
    borderRadius: "12px",
    fontSize: "12px",
  },
  Fortarget: {
    display: "flex",
    justifyContent: "flex-start",
    // width: "400px",
    "& .MuiFormControl-root": {
      " & .makeStyles-menulistscrollbox": {
        zIndex: 120,
        position: "absolute",
        marginLeft: "-50px",
      },
      // minWidth: "85%",
      "& .MuiOutlinedInput-root": {
        borderRadius: "0 8px 8px 0 !important",

        "& fieldset": {
          borderColor: colors.gray300,
        },
        "&.Mui-focused fieldset": {
          border: `1px solid ${colors.gray300}`,
        },
      },
    },
  },
  menulistscrollbox: {
    paddingX: "80px !important",
    borderRadius: "14px",
    boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
    marginTop: "40px",
    maxHeight: "300px",
    overflowY: "scroll",
    zIndex: 3232,
    position: "absolute",
    backgroundColor: colors.white,
    "&::-webkit-scrollbar": {
      width: "4px",
      marginRight: "5px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      background: colors.gray500,
      borderRadius: "8px",
      marginRight: "5px !important",
    },
  },
  menuScrollBox: {
    width: "395px",
    padding: "16px 8px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "84px !important",
  },
  loadNoData: {
    width: "395px",
    padding: "16px",
    display: "flex",
    justifyContent: "flex-start",
    height: "50px !important",
    gap: "20px",
  },
  bookedbadge: {
    color: colors.success600,
    marginRight: "40px",
    "& .MuiBadge-badge": {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0.5,
      backgroundColor: colors.success50,
    },
  },
  cardidText: {
    color: colors.gray800,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },
  cardName: {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
  },
  cardLocation: {
    color: colors.gray500,
    textOverflow: "ellipsis",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  nodatatext: {
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "32px",
    marginBottom: "20px",
  },
  checkboxText: {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px", // 150%
    letterSpacing: "0.5px",
  },
  flexBetween: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12px",
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
  },
  filterheading: {
    color: colors.gray700,
    fontFamily: "Manrope",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "28px",
  },
  plusicon: {
    marginRight: "15px",
  },
  CreateBtn: {
    backgroundColor: `${colors.success500} !important`,
    color: colors.white,
  },
  CrewModal: {
    width: "50%",
  },

  modalheading: {
    fontSize: "14px",
    fontWeight: 600,
    color: colors.brandBlue600,
    fontFamily: "manrope",
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },
  timeStyle: {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },
  commentTarget: {
    marginLeft: "10px",
    flexGrow: 1,
    "& textarea": {
      borderRadius: " 8px 8px 0 0 !important",
      height: "100px",
      borderColor: colors.gray300,
      padding: "15px",
      "&::placeholder": {
        color: colors.gray500,
        fontFamily: "Manrope",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.25px",
      },
    },
  },
  CommentActionBox: {
    marginTop: "-7px",
    padding: "20px",
    display: "flex",
    justifyContent: "flex-end",
    borderRadius: " 0 0  8px 8px !important",
    border: `1px solid ${colors.gray300} !important`,
  },

  commentModalBox: {
    // backgroundColor: "red",
    "& .MuiGrid-container": {
      // padding: "0px !important",
    },
  },
  commentDisplayBox: {
    backgroundColor: colors.gray50,
    padding: "0 iImportant",
    marginTop: "20px",
    marginRight: "-20px",
    marginLeft: "-20px",
    overflowY: "scroll",
    height: "25vh",
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: colors.gray500,
      borderRadius: "8px",
    },
  },
  commentNames: {
    color: colors.gray800,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "20px", // 142.857%
    letterSpacing: "0.1px",
  },
  commenttime: {
    color: colors.gray500,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px", // 142.857%
    letterSpacing: "0.25px",
  },
  commentsbadge: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px", // 133.333%
    letterSpacing: "0.5px",
    backgroundColor: colors.gray200,
    padding: "2px 4px",
    borderRadius: 4,
  },
  nodatasubtext: {
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  GreyBox: {
    backgroundColor: colors.gray50,
    width: "100%",
    height: "300px",
    padding: "16px",
    borderRadius: "12px",
  },
  noDataContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    // marginTop: "2px",
  },
  slectedCard: {
    color: colors.gray600,
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "20px",
  },
  slectedCardright: {
    color: colors.gray600,
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "20px",
    marginLeft: "18px",
  },
  upliftHead: {
    color: colors.gray600,
    fontSize: "16px",
    fontWeight: 600,
    // marginleft:""
  },
  timestampStyle: {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    marginTop: "15px",
  },
  footerHeading: {
    color: colors.gray700,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "150%",
  },
  checkBoxLabel: {
    color: colors.gray500,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%",
  },
  commentMapBox: {
    display: "flex",
    marginBottom: "5px",
    gap: "12px",
  },
  ReadBTn: {
    color: colors.blue600,
    textOverflow: "ellipsis",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    cursor: "pointer",
    marginLeft: "15px",
    textTransform: "none",
  },
  upliftFooter: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },

  comment: {
    color: colors.gray600,
    width: "80%",
    textOverflow: "ellipsis",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    overflow: "visible",
    whiteSpace: "normal",
    wordWrap: "break-word",
    marginRight: "30px",
  },
  commentTextBox: {
    width: "100%",
    wordWrap: "break-word",
    color: colors.gray600,
    "& p": {
      width: "90%",
      wordWrap: "break-word",
      color: colors.gray600,
      fontFamily: "Manrope",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "20px",
      letterSpacing: "0.25px",
      marginBottom: "10px",
      marginLeft: "20px",
      whiteSpace: "normal",
      overflow: "visible",
    },
  },
  CancelTask: {
    " & .makeStyles-modalBody": {
      " & .makeStyles-modalFooter": {},
    },
  },
  jobCardClickable: {
    cursor: "pointer",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: colors.gray100,
    },
  },
}));
